import { render } from "./TeamCard.vue?vue&type=template&id=a76a1326"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__